import { Card, Form } from "react-bootstrap";
import {
  SYNDICATION_FEED,
  SYNDICATION_PRIVACY,
} from "../../../constants/createWantAd";
import PremiumFeatureStar from "../../../images/v2/premium-features-stars.svg";
import PremiumPlanModal from "../../../components/PlanUpgrade/PremiumPlanModal";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const WantListingSyndication = ({
  handleFormValues,
  wantAdData,
  isDisabled,
}) => {
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );

  const [userDetails, setUserDetails] = useState(null);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);

  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  return (
    <>
      <Card className="mb-4 border-0 want-listing-syndication">
        <Card.Header className="p-0 border-0">
          <Card.Title className="mb-3 want-listing-syndication__head">
            Want-Listing Syndication
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-0 want-listing-wrapper">
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="text-muted want-listing-wrapper__label">
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      if (isDisabled) {
                        PremiumPlanModalShow();
                      }
                    }}
                  >
                    Feed
                    {isDisabled ? (
                      <div style={{ margin: "2px 5px" }}>
                        <img src={PremiumFeatureStar} alt="Premium Star" />
                      </div>
                    ) : null}
                  </div>
                </Form.Label>
                <Form.Select
                  className={`${isDisabled ? "disabled-select" : ""}`}
                  value={wantAdData?.syndicationFeed || "public"}
                  onChange={(e) =>
                    handleFormValues({
                      syndicationFeed: e.target.value,
                      focusOut: true,
                    })
                  }
                  onMouseDown={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                      PremiumPlanModalShow();
                    }
                  }}
                >
                  {Object.entries(SYNDICATION_FEED).map(([key, value]) => (
                    <option value={key}>{value}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className="text-muted want-listing-wrapper__label">
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      if (isDisabled) {
                        PremiumPlanModalShow();
                      }
                    }}
                  >
                    Privacy
                    {isDisabled ? (
                      <div style={{ margin: "2px 5px" }}>
                        <img src={PremiumFeatureStar} alt="Premium Star" />
                      </div>
                    ) : null}
                  </div>
                </Form.Label>
                <div>
                  <Form.Select
                    className={`${isDisabled ? "disabled-select" : ""}`}
                    value={wantAdData?.syndicationPrivacy || "hide"}
                    onChange={(e) => {
                      handleFormValues({
                        syndicationPrivacy: e.target.value,
                        focusOut: true,
                      });
                    }}
                    onMouseDown={(e) => {
                      if (isDisabled) {
                        e.preventDefault();
                        PremiumPlanModalShow();
                      }
                    }}
                  >
                    {Object.entries(SYNDICATION_PRIVACY).map(([key, value]) => (
                      <option value={value} key={value}>
                        {key} my agent info and contact
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Form.Group>
            </div>
          </div>
        </Card.Body>
      </Card>

      <PremiumPlanModal
        userDetails={userDetails}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        showPlanModal={PremiumPlanModalShow}
      />
    </>
  );
};

export default WantListingSyndication;
